import React from "react";
import { Controller } from "react-hook-form";
import { Box, TextField } from "@mui/material";

const PassengerForm = ({ control }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)", // 2 columns on mobile
          sm: "repeat(4, 1fr)", // 4 columns on tablet and up
        },
        gap: 2,
      }}
    >
      <Controller
        name="adults"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Adult (> 15)"
            type="number"
            fullWidth
            inputProps={{ min: 0 }}
          />
        )}
      />
      <Controller
        name="youths"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Youth (12-15)"
            type="number"
            fullWidth
            inputProps={{ min: 0 }}
          />
        )}
      />
      <Controller
        name="children"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Children (2-11)"
            type="number"
            fullWidth
            inputProps={{ min: 0 }}
          />
        )}
      />
      <Controller
        name="infants"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Infant (<2)"
            type="number"
            fullWidth
            inputProps={{ min: 0 }}
          />
        )}
      />
    </Box>
  );
};

export default PassengerForm;
